import * as React from 'react';
import { cn } from '@/lib/utils';

export function Cartao({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn('bg-cartao text-cartao-texto rounded-xl border shadow-sm', className)}
      {...props}
    />
  );
}

export function CartaoCabecalho({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('flex flex-col gap-1 p-5', className)} {...props} />;
}

export function CartaoTitulo({ className, ...props }: React.ComponentProps<'h3'>) {
  return <h3 className={cn('leading-none font-semibold tracking-tight', className)} {...props} />;
}

export function CartaoDescricao({ className, ...props }: React.ComponentProps<'p'>) {
  return <p className={cn('text-silenciado-texto text-sm', className)} {...props} />;
}

export function CartaoConteudo({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('p-5 pt-0', className)} {...props} />;
}

export function CartaoRodape({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('flex items-center gap-2 p-5 pt-0', className)} {...props} />;
}
